import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';

@Injectable()
export class SmsHttpService {

  constructor(private http: HttpClient) { }

  getSmsPurpose(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/smsprovider/purpose`).pipe(
      map(res => res.data.rows)
    );
  }

  getSmsTypes(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/smstypes`).pipe(
      map(res => res.data.rows)
    );
  }
}
